import React, { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import {
  server_post_data,
  Website_URL,
  save_update_adminsilderlink,
  get_all_adminsilderlink,
} from "../../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  handleIaphabetnumberChange,
  handleSuccessSession,
  handleError,
  handleURLChange_Modify,
} from "../../CommonJquery/CommonJquery.js";
import { useLocation, Link } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
import Loader from "./Loader.js";
import SuccesModal from "../Sections/SuccesModal.js";
function ImageDashboardAdd() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editBlogData, seteditBlogData] = useState([]);
  const [editOldImageData, seteditOldImageData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const retrievedAdminId = retrieveData("staff_id");
  const [dynaicimage, setDynaicimage] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  useEffect(() => {
    const url = currentUrl;
    const parts = url.split("/");
    if (parts.length !== 1) {
      const start_date = "";
      const end_date = "";
      const flag = "3";
      const call_id = parts[1];
      master_data_get(start_date, end_date, flag, call_id);
    }
  }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("admin_id", retrievedAdminId);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_adminsilderlink, fd)
      .then((Response) => {
        console.log(Response.data);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditBlogData(Response.data.message.data_list[0]);
          setEditorDatMainID(Response.data.message.data_list[0].primary_id);
          seteditOldImageData(Response.data.message.data_list[0].image_name);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, dynaicimage);
      fd_from.append("admin_id", retrievedAdminId);
      fd_from.append("main_id", editorDataMainID);
      fd_from.append("old_image_link", editOldImageData);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          console.log(Response.data.message);
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/imageDashboardView");
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };

  const handleFileChangedynamic = (keyname) => (event) => {
    const file = event.target.files[0];

    let new_file_name = keyname + "_show";

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setDynaicimage((prevImages) => ({
          ...prevImages,
          [keyname]: file,
          [new_file_name]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setDynaicimage((prevImages) => ({
        ...prevImages,
        [keyname]: null,
        [new_file_name]: null,
      }));
    }
  };

  return (
    <MasterLayout>
      {showLoaderAdmin && <Loader />}
      <div className="max-w-5xl  bg-white p-8 rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-2xl font-semibold mb-6">{parseInt(editorDataMainID)===0 && "Add"} {parseInt(editorDataMainID)!==0 && "Edit"} Silder </h2>
        <form className="needs-validation" id="CarrerformData">
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="validationCustom01">
                First Text<span className="red_show">*</span>
              </label>
              <input
                type="text"
                className="form-control  trio_mandatory"
                name="title_name"
                id="title_name"
                maxLength={160}
                onInput={handleIaphabetnumberChange}
                placeholder="Enter Name"
                defaultValue={editBlogData.title_name || ""}
              />
              <span className="condition_error"></span>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="validationCustom01">
                Second Text<span className="red_show">*</span>
              </label>
              <input
                type="text"
                className="form-control  trio_mandatory"
                name="title_name2"
                id="title_name2"
                maxLength={160}
                onInput={handleIaphabetnumberChange}
                placeholder="Enter Name"
                defaultValue={editBlogData.title_name2 || ""}
              />
              <span className="condition_error"></span>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="validationCustom01">
                Link<span className="red_show">*</span>
              </label>
              <input
                type="text"
                className="form-control  trio_mandatory"
                name="link_open"
                id="link_open"
                // onInput={handleURLChange_Modify}
                placeholder="Enter Link"
                defaultValue={editBlogData.link_open || ""}
              />
              <span className="condition_error"></span>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="validationCustom01">Images</label>
              <br></br>
              <input
                className="inputEditFile"
                type="file"
                name="doctor_image"
                onChange={handleFileChangedynamic("doctor_image")}
                accept=".jpg,.jpeg,.png"
              />
              <div className="previewEditBox">
                {dynaicimage && dynaicimage.doctor_image_show && (
                  <img
                    src={dynaicimage.doctor_image_show}
                    alt="Preview"
                    className="imgEditMaster"
                  />
                )}
              </div>
              <span className="condition_error"></span>
            </div>
          </div>

          <button
            className="btn btn-primary"
            type="button"
            onClick={() =>
              handleSaveChangesdynamic(
                "CarrerformData",
                save_update_adminsilderlink
              )
            }
          >
            Submit
          </button>
        </form>
      </div>
      <SuccesModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Fare Rule Added Successfully!"
        subtitle="Fare rule has been saved successfully."
        autoClose={false}
      />
    </MasterLayout>
  );
}
export default ImageDashboardAdd;
